import { useState } from "react";
import { CompanyBrowserModal, CompanyBrowserPane } from "../company-browser/CompanyBrowserModal";
import { quickCreateAccount } from "./accountCreate";
import { QuickAccountForm } from "./QuickAccountForm";

export function AccountCreateScreen({
  eventKey,
  actor,
  variant = "pane",
  onClose,
  onCreated,
}: {
  eventKey: string;
  actor: string;
  variant?: "pane" | "modal";
  onClose: () => void;
  onCreated: (accountId: string) => void;
}) {
  const [busy, setBusy] = useState(false);
  const [error, setError] = useState<string | null>(null);

  const Frame = variant === "pane" ? CompanyBrowserPane : CompanyBrowserModal;

  async function create(values: { name: string; domain: string; website: string; secondaryWebsite: string }) {
    setBusy(true);
    setError(null);
    try {
      const result = await quickCreateAccount(eventKey, actor, values);
      onCreated(result.account_id);
    } catch (err) {
      setError(err instanceof Error ? err.message : "account_upsert failed");
    } finally {
      setBusy(false);
    }
  }

  return (
    <Frame title="New account" onClose={onClose} className="contact-browser-shell">
      <header className="company-modal-header">
        <div className="company-modal-heading">
          <div className="company-modal-identity">
            <h2>New account</h2>
          </div>
          <div className="company-modal-actions">
            <button type="button" className="secondary" onClick={onClose}>
              Cancel
            </button>
          </div>
        </div>
      </header>
      <div className="company-modal-body contact-browser-body">
        <section className="contact-section">
          <p className="muted">Add a company record. Domain helps match duplicates later.</p>
          <QuickAccountForm busy={busy} error={error} onSubmit={(values) => void create(values)} />
        </section>
      </div>
    </Frame>
  );
}
